const global = window

// Remplissage automatique
inputs.behavior.subform = function (data, name, niceName, type, input, parent, inputWindow) {
    if (input.hasClass('cell')) {
        const subForm = input.find('.cell__subform')
        if (subForm.length) {
            input.addClass('cell--developable')
            input.click(function (event) {
                if (event && $(event.target).closest('a[href="javascript:;"]').length) {
                    event.preventDefault();
                }
                if (data.subscripts) {
                    eval(data.subscripts.join(''))
                    delete data.subscripts
                }

                $('.cell__subform').not(subForm).hide()
                if (subForm.length) {
                    if (subForm.is(":visible")) {
                        input.removeClass('cell--open')
                        subForm.hide()
                        $('.modalClose').hide()
                    }
                    else {
                        input.addClass('cell--open')
                        subForm.show()
                        $('.modalClose').show()
                    }

                    subForm.removeClass('cell__subform--right')
                    const windowWidth = $(window).width()
                    const elementRight = subForm.offset().left + subForm.outerWidth()

                    if (elementRight > windowWidth) {
                        subForm.addClass('cell__subform--right')
                    } else {
                        subForm.removeClass('cell__subform--right')
                    }
                }
            })
            subForm.click(function (event) {
                event.stopPropagation()
            })
        }
    }
    return data
}

$(function() {
    $('.modalClose').click(function() {
        $('.modalClose').hide()
        $('.cell__subform').hide();
        $('.cell--open').removeClass('cell--open');
    })
})